@import "../../shared/styles/breakpoints.css";

.sideNav {
  --sidenav-text: #fff;
  --sidenav-hover: rgba(255, 255, 255, 0.08);
  --sidenav-active: rgba(255, 255, 255, 0.12);
  --sidenav-border: rgba(255, 255, 255, 0.2);

  width: var(--p-sidenav-width);
  background-color: var(--p-primary-950);
  border-right: 1px solid var(--sidenav-border);
  padding: var(--p-spacing-md);
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  transition:
    width var(--p-transition-duration) ease,
    transform var(--p-transition-duration) ease-in-out;
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--p-z-nav);
  transform: translateX(-100%);
}

.sideNav.drawerOpen {
  transform: translateX(0);
}

@media (--md) {
  .sideNav {
    position: relative;
    transform: none;
    z-index: auto;
    height: 100%;
    min-height: 0;
  }

  .sideNav.collapsed {
    width: var(--p-sidenav-width-collapsed);
  }

  .sideNav.overlay {
    position: absolute;
    height: 100%;
    z-index: var(--p-z-nav);
  }

  .sideNav.overlay:not(.collapsed) {
    box-shadow: var(--p-overlay-navigation-shadow, 4px 0 24px rgba(0, 0, 0, 0.25));
  }
}

.drawerOverlay {
  position: absolute;
  inset: 0;
  background-color: var(--p-mask-background);
  z-index: var(--p-z-overlay);
  animation: fadeIn var(--p-transition-duration) ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Header */

.header {
  display: flex;
  align-items: center;
  gap: var(--p-spacing-sm);
  padding-block: var(--p-spacing-md);
  flex-shrink: 0;
}

.collapsed .header {
  justify-content: center;
  padding-inline: var(--p-spacing-xs);
}

.desktopHeader {
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.mobileHeader {
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--p-spacing-sm);
}

@media (--md) {
  .desktopHeader {
    display: flex;
  }

  .mobileHeader {
    display: none;
  }
}

.collapsed .desktopHeader {
  justify-content: center;
}

.collapsed .desktopHeader svg {
  flex-shrink: 0;
}

/* Navigation */

.nav {
  display: flex;
  flex-direction: column;
  gap: var(--p-spacing-2xs);
  flex: 1;
  overflow: hidden auto;
  min-height: 0;
}

.menuItem {
  display: flex;
  align-items: center;
  min-width: 0;
  cursor: pointer;
  color: var(--sidenav-text);
  padding: var(--p-spacing-sm) var(--p-spacing-md);
  height: var(--p-interactive-row-height);
  text-decoration: none;
  border-radius: var(--p-border-radius-sm);
  transition: background-color var(--p-transition-duration) ease;
  font-size: var(--p-font-size-sm);
  white-space: nowrap;
}

.menuItem:hover {
  background: var(--sidenav-hover);
  color: var(--sidenav-text);
  text-decoration: none;
}

.menuItem:focus-visible {
  outline: 2px solid var(--sidenav-text);
  outline-offset: -2px;
}

.menuItemActive {
  background: var(--sidenav-active);
  color: var(--sidenav-text);
  font-weight: var(--p-font-weight-medium);
}

.menuIcon {
  flex-shrink: 0;
  width: var(--icon-size-sm);
  text-align: center;
}

.menuLabel {
  margin-left: var(--p-spacing-sm);
}

.collapsed .menuItem {
  justify-content: center;
  padding: var(--p-spacing-sm);
}

/* Footer */

.footer {
  display: flex;
  flex-direction: column;
  gap: var(--p-spacing-xs);
  padding-top: var(--p-spacing-md);
  border-top: 1px solid var(--sidenav-border);
  margin-top: var(--p-spacing-md);
  flex-shrink: 0;
}

.collapsed .footer {
  align-items: center;
}

.footerButton {
  width: 100%;
  justify-content: flex-start;
}

.pinButtonRoot {
  color: #fff;
}

.pinButton:hover {
  background: var(--sidenav-hover);
}
